const DISMISS_STORAGE_KEY = "pwa_install_dismissed_at";
const DISMISS_DAYS = 14;

export const isPwaStandalone = () => {
	if (typeof window === "undefined") {
		return false;
	}

	const standaloneMedia =
		window.matchMedia &&
		window.matchMedia("(display-mode: standalone)").matches;
	const iosStandalone = window.navigator.standalone === true;
	const isTwa = document.referrer.startsWith("android-app://");

	return Boolean(standaloneMedia || iosStandalone || isTwa);
};

export const isIosDevice = () => {
	if (typeof window === "undefined") {
		return false;
	}

	const ua = window.navigator.userAgent || "";
	const iOSUa = /iPad|iPhone|iPod/.test(ua);
	const iPadOs13Plus =
		window.navigator.platform === "MacIntel" &&
		window.navigator.maxTouchPoints > 1;

	return iOSUa || iPadOs13Plus;
};

export const isAndroidDevice = () => {
	if (typeof window === "undefined") {
		return false;
	}

	return /Android/i.test(window.navigator.userAgent || "");
};

/** Phones/tablets only — excludes desktop Mac/Windows/Linux (incl. Chrome install prompts). */
export const isMobileDevice = () => isIosDevice() || isAndroidDevice();

export const wasPwaInstallDismissedRecently = (
	storage = typeof window !== "undefined" ? window.localStorage : null,
	now = Date.now()
) => {
	if (!storage) {
		return false;
	}

	try {
		const raw = storage.getItem(DISMISS_STORAGE_KEY);
		if (!raw) {
			return false;
		}

		const dismissedAt = Number(raw);
		if (!Number.isFinite(dismissedAt)) {
			return false;
		}

		const dismissMs = DISMISS_DAYS * 24 * 60 * 60 * 1000;
		return now - dismissedAt < dismissMs;
	} catch (error) {
		return false;
	}
};

export const dismissPwaInstallPrompt = (
	storage = typeof window !== "undefined" ? window.localStorage : null,
	now = Date.now()
) => {
	if (!storage) {
		return;
	}

	try {
		storage.setItem(DISMISS_STORAGE_KEY, String(now));
	} catch (error) {
		// Ignore quota / private-mode failures
	}
};

export const clearPwaInstallDismissal = (
	storage = typeof window !== "undefined" ? window.localStorage : null
) => {
	if (!storage) {
		return;
	}

	try {
		storage.removeItem(DISMISS_STORAGE_KEY);
	} catch (error) {
		// Ignore storage failures
	}
};

export const PWA_INSTALL_DISMISS_DAYS = DISMISS_DAYS;
export const PWA_INSTALL_DISMISS_KEY = DISMISS_STORAGE_KEY;
